export default __webpack_public_path__ + "static/media/Location.85e33c18.svg";